'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {ListItem} from '../../../components/lists/ListItem';
import {ProgressBar} from '../../../components/ProgressBar';
import {SvgIcon} from '../../../core-components/svg-menu-icons/SvgIcon';
import * as UPLOAD_STATUS from '../../../core-utilities/upload-service/UPLOAD_STATUS';
import {DomainImageComponent} from '../../../files/components/DomainImage/DomainImageComponent';
import {ImageView} from '../../../files/components/Image/ImageView';


export function FileFulfillmentPendingItemView(props) {
  const file = props.model;
  const {
    isImage,
    showPreview,
    previewLoading,
    url,
  } = props;
  const statusTitle = getTitle(file.uploadStatus, props);
  const progress = file.uploadStatus === UPLOAD_STATUS.UPLOADED ? 100 : props.progress;
  const isIndefinite = file.uploadStatus === UPLOAD_STATUS.UPLOADED ? false : props.isIndefinite;

  return (
    <ListItem
      className={classNames("FileFulfillmentItem", props.className)}
      bindParam={props.model}
      onClick={props.onClick}
    >
      <div className="FileFulfillmentItem__header">
        <div className="FileFulfillmentPendingItem__spacer" />
        <div className="FileFulfillmentItem__info">
          <span>
            {statusTitle}
          </span>
        </div>
        <div />
      </div>

      <div className="FileFulfillmentItem__content">
        <div className="FileFulfillmentItem__imageContainer">
          {file.uploadStatus === UPLOAD_STATUS.UPLOADING || file.uploadStatus === UPLOAD_STATUS.UPLOADED ? (
            <ProgressBar
              className="FileFulfillmentPendingItem__progressBar"
              isIndefinite={isIndefinite}
              progress={progress}
            />
          ) : null}
          {previewLoading || (isImage && showPreview) ? (
            <ImageView
              className="FileFulfillmentItem__image"
              style={DomainImageComponent.getStyle(props)}
              isLoading={previewLoading}
              title={props.name}
              url={url}
              displayWidth={props.displayWidth}
              displayHeight={props.displayHeight}
            />
          ) : (
            <SvgIcon
              className="FileFulfillmentItem__fileIcon"
              isFile={true}
              filename={file.name}
            />
          )}
        </div>
      </div>
    </ListItem>
  );
}

function getTitle(status, props) {
  switch (status) {
    case UPLOAD_STATUS.PENDING:
      return props.pendingLabel;

    case UPLOAD_STATUS.UPLOADING:
      return props.uploadingLabel;

    case UPLOAD_STATUS.UPLOADED:
      return props.uploadedLabel;

    default:
      return '';
  }
}

FileFulfillmentPendingItemView.propTypes = {
  className: T.string,

  model: T.object,
  name: T.string,

  isImage: T.bool,
  showPreview: T.bool,
  previewLoading: T.bool,
  url: T.string,
  progress: T.number,
  isIndefinite: T.bool,

  pendingLabel: T.string,
  uploadingLabel: T.string,
  uploadedLabel: T.string,
};

FileFulfillmentPendingItemView.defaultProps = {
  className: '',
};

FileFulfillmentPendingItemView.messages = [
  {code: 'files.uploads.pending.label', prop: 'pendingLabel'},
  {code: 'files.uploads.uploading.label', prop: 'uploadingLabel'},
  {code: 'files.uploads.uploaded.label', prop: 'uploadedLabel'},
];

FileFulfillmentPendingItemView.messageProps = [
  'pendingLabel',
  'uploadingLabel',
  'uploadedLabel',
];



// WEBPACK FOOTER //
// ./src/js/requirements/components/FileFulfillmentPendingItem/FileFulfillmentPendingItemView.js